import classNames from 'classnames';
import { FormikProps, FormikProvider } from 'formik';
import { ReactNode } from 'react';
import { Button, Tooltip } from 'ui';

export interface OnboardingWrapperProps {
  title?: string;
  titleHint?: string;
  children: ReactNode;
  onClickContinue?: () => void;
  onClickSkip?: () => void;
  buttonSkipName?: string;
  buttonContinueHint?: string | ReactNode;
  formik?: FormikProps<any>;
  isLoading?: boolean;
  disableNext?: boolean;
  className?: string;
}

export const OnboardingWrapper = ({
  title,
  children,
  onClickContinue,
  formik,
  isLoading,
  disableNext,
  onClickSkip,
  className,
  buttonSkipName = 'Skip',
  buttonContinueHint,
  titleHint,
}: OnboardingWrapperProps) => {
  const Body = (
    <div
      className={classNames(
        'flex flex-col space-y-10',
        {
          'w-full': !className?.includes('w-'),
        },
        className,
      )}
    >
      {title && (
        <Tooltip
          position="up"
          positionHorizontal="center"
          variant="black"
          disabled={!titleHint}
          button={
            <span
              style={{ wordBreak: 'break-word' }}
              className={classNames(
                'sm:text-[48px] sm:leading-[56px] text-[38px] leading-[46px] font-semibold font-[RecifeDisplay] break-words',
                {
                  'cursor-help': !!titleHint,
                },
              )}
            >
              {title}
            </span>
          }
        >
          {titleHint}
        </Tooltip>
      )}
      {children}
      <div className="w-full flex flex-col items-center justify-between gap-4">
        {onClickContinue && (
          <Tooltip
            position="up"
            positionHorizontal="center"
            variant="gray"
            classNameTooltip="border"
            className="w-full"
            button={
              <Button
                className="w-full relative"
                type="submit"
                onClick={onClickContinue}
                disabled={isLoading || disableNext}
              >
                Continue
              </Button>
            }
            disabled={!buttonContinueHint}
          >
            <span>{buttonContinueHint}</span>
          </Tooltip>
        )}
        {onClickSkip && (
          <Button className="w-full" variant="secondary" type="submit" onClick={onClickSkip}>
            {buttonSkipName}
          </Button>
        )}
      </div>
    </div>
  );

  if (formik) {
    return <FormikProvider value={formik}>{Body}</FormikProvider>;
  }

  return <>{Body}</>;
};
